import { ShiftDirectionEnum } from '../../../../common/enum/shift-direction.enum';
import { InternalServerErrorException } from '../../../../common/exceptions/exceptions';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { shiftDateToNearestGranularity } from '../../../../common/utils/datetime.util';
import { MetricValueType } from '../../../../interface/dtos';
import { GetChallengeInsightProgressSummaryRequestDto } from '../../../../interface/dtos/challenge-insights/get-challenge-insight-progress-summary.request.dto';
import { ChallengeInsightProgressSentimentSummaryAggregateRoot } from '../../../domain/aggregates/challenge-insights/challenge-insight-progress-sentiment.aggregate-root';
import { GetChallengeInsightProgressSentimentSummaryDomainService } from '../../../domain/services/challenge-insights/get-challenge-insight-progress-sentiment-summary.domain-service';
import { OrgSentimentReportPort } from '../../ports/org-sentiment-report/org-sentiment-report.port';

export class GetChallengeInsightProgressSentimentSummaryApplicationService {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly port: OrgSentimentReportPort,
    protected readonly domainService: GetChallengeInsightProgressSentimentSummaryDomainService
  ) {}

  async execute(
    props: GetChallengeInsightProgressSummaryRequestDto
  ): Promise<ChallengeInsightProgressSentimentSummaryAggregateRoot> {
    try {
      this.logManager.debug(
        'Called GetChallengeInsightProgressSentimentSummaryApplicationService'
      );

      const shiftedEndDate = shiftDateToNearestGranularity({
        date: new Date(props.params.endDate),
        granularity: props.params.granularity,
        direction: ShiftDirectionEnum.Left,
      });
      const [entities, todayEntities] = await Promise.all([
        this.port.getAverageSentimentForUserIdsForDateRange({
          startDate: props.params.startDate,
          endDate: props.params.endDate,
          userIds: props.params.userIds,
          token: props.config.token,
          granularity: props.params.granularity,
          segments: props.params.segments ?? undefined,
          departmentId: props.params.departmentId ?? undefined,
        }),
        this.port.getAverageSentimentForUserIdsForDateRange({
          startDate: shiftedEndDate.toISOString().split('T')[0],
          endDate: props.params.endDate,
          userIds: props.params.userIds,
          token: props.config.token,
          granularity: props.params.granularity,
          departmentId: props.params.departmentId ?? undefined,
        }),
      ]);
      return await this.domainService.execute({
        entities,
        systemDayEntities: todayEntities,
        type: MetricValueType.Score,
        targetValue: props.params.challengeTargetValue,
      });
    } catch (error) {
      this.logManager.error(error);
      throw new InternalServerErrorException(error);
    }
  }
}
